import React, { useState, useEffect } from "react";
import CommonTable from "./CommonTable";
import {
  tableData,
  TableHeadersActivityAndApprovalsStyles,
} from "./socialCalendarConstants";
import Drawer from "../../components/common/DrawerUpdated";
import PostPreview from "./PostPreview";

const Approvals = ({ recentPosts, getAllPost, getType }) => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  const handleCellClick = (rowData) => {
    const clickedPostId = rowData.postId?.$oid || rowData.postId;

    const fullPostData = getAllPost.find((post) => {
      const postId = post._id?.$oid || post._id;
      return postId === clickedPostId;
    });

    if (fullPostData) {
      const normalizedPost = {
        ...fullPostData,
        _id: fullPostData._id?.$oid || fullPostData._id,
      };
      setSelectedPost(normalizedPost);
      setOpenSidebar(true);
    } else {
      console.warn("Post data not found for ID:", clickedPostId);
    }
  };

  useEffect(() => {
    if (selectedPost) {
    }
  }, [selectedPost]);

  const tableRows = getAllPost
    .filter((item) => item.schedule?.isScheduled === true)
    .map((item, index) => {
      const fileURL =
        item.images?.length && item.images[0].url
          ? `${item.images[0].url}`
          : "";

      return {
        sNo: index + 1,
        date: new Date(item.createdAt).toLocaleString(),
        post: (
          <span
            className="text-blue-500 flex justify-center items-center
             cursor-pointer"
            onClick={() => handleCellClick({ postId: item._id })}
          >
            {getType(item?.images[0]?.url) === "image" ? (
              <img
                src={item?.images[0]?.url}
                alt={`media-${index}`}
                className=" h-[30px] object-cover"
              />
            ) : getType(item?.images[0]?.url) === "video" ? (
              <video
                src={item?.images[0]?.url}
                className=" h-[30px] object-cover"
              />
            ) : null}
          </span>
        ),
        platforms: item.platforms
          .map((platform) => platform.platformName)
          .join(", "),
        outlet: item.accounts.map((account) => account.accountName).join(", "),
        requestedBy: "N/A",
        status: (
          <span
            className={`font-bold ${
              item.status === "pending_approval"
                ? "text-yellow-600"
                : item.status === "published"
                ? "text-green-600"
                : item.status === "failed"
                ? "text-red-600"
                : "text-gray-600"
            }`}
          >
            {item.status === "pending_approval"
              ? "Approval Pending"
              : item.status === "published"
              ? "Published"
              : item.status === "failed"
              ? "Failed"
              : item.status}
          </span>
        ),
        postId: item._id,
      };
    });

  return (
    <div>
      <CommonTable
        headers={TableHeadersActivityAndApprovalsStyles}
        data={tableRows}
        cellFunction={handleCellClick}
      />

      {selectedPost && (
        <Drawer
          isOpen={openSidebar}
          onClose={() => setOpenSidebar(false)}
          DrawerTitle="Post"
          width="w-[50%]"
          DrawerContent={
            <PostPreview
              postContent={selectedPost}
              showApproval={true}
              close={() => setOpenSidebar(false)}
            />
          }
        />
      )}
    </div>
  );
};

export default Approvals;
